import { render, staticRenderFns } from "./consultLabelList.vue?vue&type=template&id=72856088"
import script from "./consultLabelList.vue?vue&type=script&lang=js"
export * from "./consultLabelList.vue?vue&type=script&lang=js"
import style0 from "./consultLabelList.vue?vue&type=style&index=0&id=72856088&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports